
import { defineComponent, watch, onMounted, ref } from 'vue';

import { Modal as ModalType } from 'bootstrap';
import Modal from 'bootstrap/js/src/modal';


export default defineComponent({
  name: 'Modal',
  props: {
    title: String,
    variant: String,
    isActive: Boolean,
    hideAction: Boolean,
    customAction: String,
  },
  setup(props, { emit }) {
    const modalRef = ref(null);

    const setIsActive: (modal: ModalType | null, isActive: boolean, isActiveP: boolean) => void = (
      modal,
      isActive,
      isActiveP
    ) => {
      if (!modal) return;

      if (isActive === isActiveP) {
        return;
      }

      if (isActive) {
        modal.show();
        return;
      }

      modal.hide();
    };

    let modal: null | ModalType = null;
    onMounted(() => {
      modal = new Modal(modalRef.value);

      ((modalRef.value as unknown) as Element).addEventListener('hidden.bs.modal', () => {
        emit('close-modal');
      });

      setIsActive(modal, props.isActive || false, !props.isActive);
    });

    watch(
      () => props.isActive,
      (isActive, isActiveP) => setIsActive(modal, !!isActive, !!isActiveP)
    );

    return {
      modalRef,
    };
  },
});
